import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { BusinessReportItem } from 'src/modules/motor-credito/serasa/serasa.experian.business.types'

export type EnderecoProps = {
    empresa: BusinessReportItem
}

export default function Endereco({ empresa }: EnderecoProps) {
    return (
        <>
            <Divider textAlign="center">Endereço</Divider>

            <Grid
                container
                spacing={1}
                sx={{
                    paddingTop: 2,
                    paddingBottom: 2,
                    paddingLeft: 5,
                    paddingRight: 5
                }}
            >
                <GridItem label="Endereço" value={empresa.identificationReport.address?.addressLine || '-'} xs={12} />
                <GridItem label="Cidade" value={empresa.identificationReport.address?.city || '-'} xs={12} />
                <GridItem label="Estado" value={empresa.identificationReport.address?.state || '-'} xs={12} />
                <GridItem label="CEP" value={empresa.identificationReport.address?.zipCode || '-'} xs={12} />
            </Grid>
        </>
    )
}
